import highmarkRulesTypes from './high-mark-rules.type';

/** ***************** ADD HIGHMARK RULES START *********************** */
export const addHighmarkRulesStart = (addData: any) => ({
	type: highmarkRulesTypes.ADD_HIGHMARK_RULES_START,
	payload: addData,
});

export const addHighmarkRulesSuccess = (successData: any) => ({
	type: highmarkRulesTypes.ADD_HIGHMARK_RULES_SUCCESS,
	payload: successData,
});

export const addHighmarkRulesFailure = (failureData: any) => ({
	type: highmarkRulesTypes.ADD_HIGHMARK_RULES_FAILURE,
	payload: failureData,
});

export const addHighmarkRulesResponseResetStart = () => ({
	type: highmarkRulesTypes.ADD_HIGHMARK_RULES_RESPONSE_RESET,
});

export const addHighmarkRulesResponseChanged = () => ({
	type: highmarkRulesTypes.ADD_HIGHMARK_RULES_RESPONSE_CHANGED,
});

/** ***************** ADD HIGHMARK RULES END *********************** */

/** ***************** FETCH HIGHMARK RULES START *********************** */
export const fetchHighmarkRulesStart = (fetchData: any) => ({
	type: highmarkRulesTypes.FETCH_HIGHMARK_RULES_START,
	payload: fetchData,
});

export const fetchHighmarkRulesSuccess = (successData: any) => ({
	type: highmarkRulesTypes.FETCH_HIGHMARK_RULES_SUCCESS,
	payload: successData,
});

export const fetchHighmarkRulesFailure = (failureData: any) => ({
	type: highmarkRulesTypes.FETCH_HIGHMARK_RULES_FAILURE,
	payload: failureData,
});

export const fetchHighmarkRulesResponseResetStart = () => ({
	type: highmarkRulesTypes.FETCH_HIGHMARK_RULES_RESPONSE_RESET,
});

export const fetchHighmarkRulesResponseChanged = () => ({
	type: highmarkRulesTypes.FETCH_HIGHMARK_RULES_RESPONSE_CHANGED,
});
/** ***************** FETCH HIGHMARK RULES START *********************** */
